export const chartBoxRevenue = {
  color: "teal",
  dataKey: "revenue",
  chartData: [
    { name: "Sun", revenue: 400 },
    { name: "Mon", revenue: 600 },
    { name: "Tue", revenue: 500 },
    { name: "Wed", revenue: 700 },
    { name: "Thu", revenue: 400 },
    { name: "Fri", revenue: 500 },
    { name: "Sat", revenue: 450 },
  ],
};
export const chartBoxSubscriber = {
  color: "#FF8042",
  dataKey: "users",
  chartData: [
    { name: "Sun", users: 400 },
    { name: "Mon", users: 600 },
    { name: "Tue", users: 500 },
    { name: "Wed", users: 700 },
    { name: "Thu", users: 400 },
    { name: "Fri", users: 500 },
    { name: "Sat", users: 450 },
  ],
};
export const chartBoxQuery = {
  color: "gold",
  dataKey: "query",
  chartData: [
    { name: "Sun", query: 400 },
    { name: "Mon", query: 600 },
    { name: "Tue", query: 500 },
    { name: "Wed", query: 700 },
    { name: "Thu", query: 400 },
    { name: "Fri", query: 500 },
    { name: "Sat", query: 450 },
  ],
};
export const PieData = [
  { name: "Paid", value: 300, color: "#FFBB28" },
  { name: "Free", value: 200, color: "#FF8042" },
];
export const BarChartData = {
  title: "User per month",
  color: "teal",
  dataKey: "user",
  chartData: [
    {
      name: "Nov",
      user: 0,
    },
    {
      name: "Dec",
      user: 1,
    },
    {
      name: "Jan",
      user: 1,
    },
    {
      name: "Feb",
      user: 0,
    },
    {
      name: "Mar",
      user: 1,
    },
    {
      name: "Oct",
      user: 1,
    },
  ],
};

export const CurrencyPairData = [
  {
    currencypair: "USD/EUR",
    value: "0.9176",
  },
  {
    currencypair: "USD/GBP",
    value: "0.7811",
  },
  {
    currencypair: "USD/AUD",
    value: "1.4998",
  },
];
